import { useTranslations } from "next-intl";
import classNames from "classnames";
import sizeEquivalenceTables from "@utils/sizeEquivalenceTables";
import { SIZE_TYPES_SHOWING_IT_EQUIVALENCE } from "@utils/constants/sizeTypesShowingITEquivalence";

const customer = process.env.NEXT_PUBLIC_CUSTOMER;

function SizeEquivalenceTable({ sizeType, selectedSizeReference }) {
  const t = useTranslations("common");

  const showITColumn = SIZE_TYPES_SHOWING_IT_EQUIVALENCE.includes(sizeType);
  const ITFirstColumn = showITColumn && selectedSizeReference === "IT";
  const ITTable = showITColumn ? sizeEquivalenceTables[customer]["size_it"] : null;

  return (
    <table
      className="table mt-5 text-center"
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <thead className="pt-5">
        <tr className="pt-3">
          {ITFirstColumn && (
            <th className="border-0 bg-transparent">{t("size_reference_table_title.size_it")}</th>
          )}
          <th className="border-0 bg-transparent">{t(`size_reference_table_title.${sizeType}`)}</th>
          {showITColumn && !ITFirstColumn && (
            <th className="border-0 bg-transparent">{t("size_reference_table_title.size_it")}</th>
          )}
          <th className="border-0 bg-transparent">{t("size_reference_table_title.size_ref")}</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(sizeEquivalenceTables[customer][sizeType]).map(([key, value], index) => {
          const bg = index % 2 === 0 ? "bg-white" : "bg-light-gray";
          const ITKey = ITTable ? Object.keys(ITTable).find((k) => ITTable[k] === value) : null;

          return (
            <tr
              key={key}
              className={classNames("border-0", bg)}
            >
              {ITFirstColumn && (
                <td
                  className={classNames("border-0 text-center", {
                    "fw-bold": showITColumn,
                  })}
                >
                  {ITKey}
                </td>
              )}
              <td
                className={classNames("border-0 text-center", {
                  "fw-bold": !ITFirstColumn && showITColumn,
                })}
              >
                {key}
              </td>
              {showITColumn && !ITFirstColumn && <td className="border-0 text-center">{ITKey}</td>}
              <td className="border-0 text-center">{value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default SizeEquivalenceTable;
